import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface FortMonitorCredentials {
  login: string
  password: string
}

interface FortMonitorState {
  credentials: FortMonitorCredentials | null
  server: string | null
  setCredentials: (credentials: FortMonitorCredentials) => void
  setServer: (server: string) => void
  clearCredentials: () => void
  clearServer: () => void
}

export const useFortMonitorStore = create<FortMonitorState>()(
  persist(
    (set) => ({
      credentials: null,
      server: null,

      setCredentials: (credentials: FortMonitorCredentials) => {
        set({ credentials })
      },

      setServer: (server: string) => {
        set({ server })
      },

      clearCredentials: () => {
        set({ credentials: null })
      },

      clearServer: () => {
        set({ server: null })
      },
    }),
    {
      name: 'fortmonitor-storage',
      partialize: (state) => ({
        credentials: state.credentials,
        server: state.server,
      }),
    }
  )
)
